import { Navigate } from 'react-router';

import { useCurrentContributorContext } from 'app/CurrentContributorProvider';
import { TemporaryAccess } from './TemporaryAccess';

export const TemporaryAccessRoute = () => {
    const { currentContributor } = useCurrentContributorContext();

    if (!currentContributor.isCompanySupport) {
        return <Navigate to={'/unauthorized'} replace />;
    }

    return <TemporaryAccess />;
};
